import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Bank, BankCreate, BankFilter } from '../data/bank';

export function createBankService(client: AxiosInstance) {
  return createCrudService<Bank, BankCreate, BankFilter>(
    client,
    '/master-data/Bank',
    'bankId',
  );
}

export type BankService = CrudService<Bank, BankCreate, BankFilter>;
